module.exports = __webpack_public_path__ + "fontawesome-webfont.a3de2170e4e9df77161e.ttf";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/fonts/fontawesome-webfont.ttf?v=4.1.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.ttf?v=4.1.0
// module chunks = styles